<template>
  <v-layout 
   pt-5
  mt-4
  justify-center>
   <v-flex xs6>
   <v-img
      :src="src"
      />
      </v-flex>
    <v-flex
      xs6  
    >
      <panel title="Forgot Password?">
        <form
          name="login-form"
          autocomplete="on"
        >
          <v-text-field
            v-model="email"
            label="Email"
          />
          <br>
        </form>
        <v-btn
          :color="strongColor"
          dark
          @click="forgotPassword"
          >
          Request Password Reset
        </v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>



<script>
import { mapState } from "vuex";
import { STRONG_COLOR } from "@/components/globals/consts";
import rmp_tagline from '@/assets/rmp_tagline.png'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data() {
    return {
      strongColor: STRONG_COLOR,
      src: rmp_tagline,
      email: null,
      error: null
    }
  },
  methods: {
    async forgotPassword() {
        try { 

        const response = await AuthenticationService.forgotPassword({
            email: this.email.trim().toLowerCase()
        })
        this.$router.push({
            name: 'reset-password-submitted'
        })

    } 
      catch (error) {
        console.log(error)
			}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue